// extracted by mini-css-extract-plugin
var _1 = "ra-art-card-additional-content";
var _2 = "ra-art-card-background";
var _3 = "ra-art-card-border";
var _4 = "1px";
var _5 = "ra-art-card";
var _6 = "ra-art-card-detail";
var _7 = "ra-art-card-style-1";
var _8 = "ra-art-card-style-2";
var _9 = "ra-art-card-style-3";
var _a = "ra-art-card-style-4";
var _b = "ra-art-card-style-5";
var _c = "ra-art-card-style-8";
var _d = "ra-art-card-footer";
var _e = "ra-art-card-footer-left";
var _f = "ra-art-card-footer-right";
var _10 = "ra-art-card-heading";
var _11 = "ra-art-card-heading-flex";
var _12 = "ra-art-card-link-artist";
var _13 = "ra-art-card-link-artwork";
var _14 = "ra-art-card-link";
var _15 = "ra-art-card-hover-media";
var _16 = "ra-art-card-more-info";
var _17 = "ra-art-card-over-image";
var _18 = "ra-art-card-over-image-label";
var _19 = "ra-art-card-over-image-section";
var _1a = "ra-art-card-over-image-section-right";
var _1b = "ra-art-card-overlay-btn";
var _1c = "ra-art-card-picture";
var _1d = "ra-art-card-touch";
export { _1 as "artCardAdditionalContentCls", _2 as "artCardBackgroundCls", _3 as "artCardBorderCls", _4 as "artCardBorderSize", _5 as "artCardCls", _6 as "artCardDetailCls", _7 as "artCardDisplayStyle1Cls", _8 as "artCardDisplayStyle2Cls", _9 as "artCardDisplayStyle3Cls", _a as "artCardDisplayStyle4Cls", _b as "artCardDisplayStyle5Cls", _c as "artCardDisplayStyle8Cls", _d as "artCardFooterCls", _e as "artCardFooterLeftCls", _f as "artCardFooterRightCls", _10 as "artCardHeadingCls", _11 as "artCardHeadingFlexCls", _12 as "artCardLinkArtistCls", _13 as "artCardLinkArtworkCls", _14 as "artCardLinkCls", _15 as "artCardMediaHoverCls", _16 as "artCardMoreInfoCls", _17 as "artCardOverImageCls", _18 as "artCardOverImageLabelCls", _19 as "artCardOverImageSectionCls", _1a as "artCardOverImageSectionRightCls", _1b as "artCardOverlayBtnCls", _1c as "artCardPictureCls", _1d as "artCardTouchCls" }
